import type { ChatUserSearchResponseContentItem } from './chatUserSearchResponseContentItem';

export interface ChatUserSearchResponse {
  content: ChatUserSearchResponseContentItem[];
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  totalElements: number;
  totalPages: number;
}
